import React from "react";
// import { Offcanvas } from "react-bootstrap"; // Removed

const OffCanvas = ({
  show,
  handleClose,
  title,
  children,
  placement = "start",
  width = "400px",
}) => {
  // Placement classes
  const placementClasses = {
    start: "left-0 top-0 bottom-0 border-r border-lightGray transform",
    end: "right-0 top-0 bottom-0 border-l border-lightGray transform",
    top: "top-0 left-0 right-0 border-b border-lightGray transform",
    bottom: "bottom-0 left-0 right-0 border-t border-lightGray transform",
  };

  const translateClasses = {
    start: show ? "translate-x-0" : "-translate-x-full",
    end: show ? "translate-x-0" : "translate-x-full",
    top: show ? "translate-y-0" : "-translate-y-full",
    bottom: show ? "translate-y-0" : "translate-y-full",
  };

  return (
    <>
      {/* Backdrop */}
      {show && (
        <div
          className="fixed inset-0 bg-dark/50 backdrop-blur-sm z-[1040] transition-opacity duration-300"
          onClick={handleClose}
        ></div>
      )}

      {/* Offcanvas Panel */}
      <div
        className={`fixed bg-white shadow-2xl z-[1050] transition-transform duration-300 ease-in-out flex flex-col
          ${placementClasses[placement] || placementClasses.start}
          ${translateClasses[placement] || translateClasses.start}
        `}
        style={{ width: ['start', 'end'].includes(placement) ? width : '100%', height: ['top', 'bottom'].includes(placement) ? width : '100%' }}
      >
        <div className="flex justify-between items-center p-4 border-b border-lightGray">
          <h5 className="text-lg font-bold m-0 text-dark">{title}</h5>
          <button
            type="button"
            className="text-gray-400 hover:text-dark transition-colors text-xl leading-none"
            onClick={handleClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-0">
          {children}
        </div>
      </div>
    </>
  );
};

export default OffCanvas;
